var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75169 1.83673C5.75169 2.502 5.18958 3.07347 4.45587 3.07347C3.72217 3.07347 3.16006 2.502 3.16006 1.83673C3.16006 1.17147 3.72217 0.6 4.45587 0.6C5.18958 0.6 5.75169 1.17147 5.75169 1.83673Z",
    stroke: "#2E7161",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7029 6.73468C12.7029 7.39995 12.1408 7.97142 11.407 7.97142C10.6733 7.97142 10.1112 7.39995 10.1112 6.73468C10.1112 6.06942 10.6733 5.49795 11.407 5.49795C12.1408 5.49795 12.7029 6.06942 12.7029 6.73468Z",
    stroke: "#2E7161",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75169 11.6326C5.75169 12.2979 5.18958 12.8694 4.45587 12.8694C3.72217 12.8694 3.16006 12.2979 3.16006 11.6326C3.16006 10.9674 3.72217 10.3959 4.45587 10.3959C5.18958 10.3959 5.75169 10.9674 5.75169 11.6326Z",
    stroke: "#2E7161",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.948145,
    y1: 1.54288,
    x2: 2.2759,
    y2: 1.54288,
    stroke: "#2E7161",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.89956,
    y1: 1.54282,
    x2: 15.2307,
    y2: 1.54282,
    stroke: "#2E7161",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5868,
    y1: 6.44077,
    x2: 15.2305,
    y2: 6.44077,
    stroke: "#2E7161",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.948145,
    y1: 6.44077,
    x2: 7.96334,
    y2: 6.44077,
    stroke: "#2E7161",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.948145,
    y1: 11.3387,
    x2: 2.59187,
    y2: 11.3387,
    stroke: "#2E7161",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.89956,
    y1: 11.3387,
    x2: 15.2307,
    y2: 11.3387,
    stroke: "#2E7161",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.86e2e5626819f8577c3a87081ea36097.svg";
export { ForwardRef as ReactComponent };